import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import axios from 'axios';
import { baseUrl } from '../../utils/api';

const StreamGuard = ({ children }) => {
  const { streamId } = useParams();
  const [isValidating, setIsValidating] = useState(true);
  const [isValidStream, setIsValidStream] = useState(false);

  useEffect(() => {
    const validateStreamId = async () => {
      try {
        const decodedStreamId = decodeURIComponent(streamId || '');
    
        if (!decodedStreamId.trim()) {
          setIsValidating(false);
          setIsValidStream(false);
          return;
        }

        const host = window.location.hostname;
        const primary = (host === 'localhost' || host === '127.0.0.1') 
          ? 'http://localhost:5000' 
          : baseUrl.replace('/v1', '');
        const fallback = (primary.includes('localhost')) 
          ? baseUrl.replace('/v1', '') 
          : 'http://localhost:5000';
        const candidates = [primary, fallback].filter((v, i, arr) => arr.indexOf(v) === i);

        let validFolders = [];
        
        for (const root of candidates) {
          try {
            const response = await axios.get(`${root}/v1/stream/folders`);
            const folders = response.data?.folders || [];
            
            validFolders = folders.map(item => {
              if (typeof item === 'string') {
                return item;
              }
              return item.name;
            });
            
            break;
          } catch (error) {
            continue;
          }
        }

        const isValid = validFolders.includes(decodedStreamId);
        
        setIsValidStream(isValid);
        setIsValidating(false);
        
      } catch (error) {
        console.error('Error validating stream ID:', error);
        setIsValidStream(false);
        setIsValidating(false);
      }
    };

    validateStreamId();
  }, [streamId]);

  if (isValidating) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '200px',
        fontSize: '16px',
        color: '#666'
      }}>
        Validating stream...
      </div>
    );
  }

  if (!isValidStream) {
    return <Navigate to="/live-streams" replace />;
  }

  return children;
};

export default StreamGuard;